export enum TransactionPayoutStateEnum {
  // “Paid” - all usual transactions which was paid immediately on creation (Stripe and other systems which already have integration)
  Paid = 0,
  // “Requested” - transaction was created, but will be paid later, for example by sending NACHA file to Tabapay (no integration)
  Requested = 1,
}

export const TransactionPayoutStateToName = {
  [TransactionPayoutStateEnum.Paid]: 'Paid',
  [TransactionPayoutStateEnum.Requested]: 'Requested',
};
